import React from "react";
import styles from "./SingleLawyer.module.scss";
import Arrow from "../../../assets/img/arrow_r_small.png";
import IconCalendar from "../../../assets/img/calendar_green.png";
import Button from "@material-ui/core/Button";
import Camera from "../../../assets/img/camera.png";
import { withStyles } from "@material-ui/core/styles";
import Rating from "@material-ui/lab/Rating";
import api from "../../../services/Api";
import Profile from "./Profile/Profile";
import Opinions from "./Opinions/Opinions";
import PriceList from "./PriceList/PriceList";
import Schedules from "./Schedules/Schedules";
import OrderConsultation from "../OrderConsultation/OrderConsultation";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
import StarBorderRoundedIcon from "@material-ui/icons/StarBorderRounded";
import { ReactComponent as CalendarIcon2 } from "../../../assets/svg/calendar.svg";
import classNames from "classnames";
import Image from "../../../services/Image";
import PersonRoundedIcon from "@material-ui/icons/PersonRounded";
import User from "../../../services/User";
import "moment/locale/pl";
import { Link } from "react-router-dom";
import { encodeBase64String } from "src/helpers/common";
const moment = require("moment");
moment.locale("pl");

const StyledRating = withStyles({
  icon: {
    margin: "-3px 0px -3px -3px",
  },
})(Rating);

class SingleLawyer extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      opinions: false,
      schedules: null,
      firstFreeDay: "--",
      //services: this.props.lawyer && this.props.lawyer.services,
      //price: this.props.lawyer && this.props.lawyer.price,
      showOrder: false,
      selectedTime: [],
      price: null,
    };
  }

  componentDidMount() {
    // console.log('lawyer', this.props.lawyer.id);
    if (this.props.lawyer) {
      api.get("/opinions/lawyer/" + this.props.lawyer.id).then((response) => {
        if (response.status === 200 && response.data.success === true) {
          this.setState({
            opinions: response.data.data,
          });
        }
      });

      api.get("/schedules/" + this.props.lawyer.id).then((response) => {
        if (response.status === 200 && response.data.success === true) {
          this.setState({
            schedules: response.data.data,
          });

          let count = 0;
          let whenText = null;
          let today = new Date();
          today.setHours(0, 0, 0, 0);
          let now = new Date();
          let tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);
          let afterTomorrow = new Date();
          afterTomorrow.setDate(tomorrow.getDate() + 1);
          var months = [
            "Styczeń",
            "Luty",
            "Marzec",
            "Kwiecień",
            "Maj",
            "Czerwiec",
            "Lipiec",
            "Sierpień",
            "Wrzesień",
            "Październik",
            "Listopad",
            "Grudzień",
          ];
          let when = "";

          response.data.data.map((schedule) => {
            schedule.list.map((single) => {
              let day = new Date(single.start);
              if (day >= now && single.free) {
                day.setHours(0, 0, 0, 0);
                if (count === 0) {
                  if (today.getDate() == day.getDate()) when = "dzisiaj, ";
                  else if (tomorrow.getDate() == day.getDate())
                    when = "jutro, ";
                  else if (afterTomorrow.getDate() == day.getDate())
                    when = "pojutrze, ";
                  whenText =
                    when + " " + day.getDate() + " " + months[day.getMonth()];
                  this.setState({
                    firstFreeDay: whenText,
                  });
                  count++;
                  return;
                }
              }
            });
          });
        }
      });

      if (this.props.shouldFetchPrice) {
        this.fetchPrice();
      }
    }

    const { lawyer } = this.props;
    if (lawyer && lawyer.imageId) {
      Image.getImage(lawyer.imageId).then((imageUrl) => {
        this.setState({
          imageUrl: imageUrl,
        });
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (this.props.shouldFetchPrice && prevProps.domain != this.props.domain) ||
      prevProps.lawyer != this.props.lawyer
    ) {
      this.fetchPrice();
    }
  }

  fetchPrice = () => {
    if (!this.props.lawyer) return;
    api
      .get("lawyers/" + this.props.lawyer.id + "/services")
      .then((response) => {
        if (response.status === 200 && response.data.success === true) {
          const foundService = response.data.data.find(
            (service) =>
              service.Domain && service.Domain.id === this.props.domain
          );
          let price = null;
          if (foundService) {
            price = foundService.price;
            this.props.lawyer.price = price;
            this.forceUpdate();
          }
        }
      });
  };

  nearestHours = () => {
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    let now = new Date();
    let day = null;
    let startHour = null;
    let endHour = null;

    if (this.state.schedules) {
      let found = false;

      return this.state.schedules.map((schedule) => {
        day = new Date(schedule.date);
        day.setHours(0, 0, 0, 0);

        if (found) return;

        if (day >= today) {
          return schedule.list.map((hour) => {
            startHour = new Date(hour.start);
            if (hour.free && startHour >= now && !hour.reserved) {
              found = true;
              endHour = new Date(hour.end);
              return (
                <span
                  key={startHour}
                  className={styles.hour}
                  onClick={() =>
                    this.toggleOrder(new Date(hour.start), new Date(hour.end))
                  }
                >
                  {startHour.getHours()}:
                  {startHour.getMinutes() < 10
                    ? "0" + startHour.getMinutes()
                    : startHour.getMinutes()}
                </span>
              );
            }
          });
        }
      });
    }
  };

  toggleSchedules = () => {
    this.props.setCurrentLawyer &&
      this.props.setCurrentLawyer(this.props.lawyer.id, this.state.imageUrl);
    this.props.setBoxContent(
      true,
      <Schedules
        lawyer={this.props.lawyer}
        schedules={this.state.schedules}
        toggleOrder={this.toggleOrder}
        toggleProfile={this.toggleProfile}
        domain={this.props.domain}
      />,
      "Harmonogram",
      this.props.lawyer.lawyerStatus +
        " " +
        this.props.lawyer.name +
        " " +
        this.props.lawyer.surname,
      null,
      <Button variant="contained" color="primary" onClick={this.toggleProfile}>
        Pokaż profil
      </Button>
    );
  };

  toggleOrder = (from, to, isNew = true, domain) => {
    this.props.setCurrentLawyer &&
      this.props.setCurrentLawyer(this.props.lawyer.id, this.state.imageUrl);
    if (this.props.setSelectedDate) {
      this.props.setSelectedDate(from, to);
    }

    this.setState({
      selectedTime: {
        start: from,
        end: to,
      },
    });

    api
      .post("/reservedAppointments", {
        lawyerId: this.props.lawyer.id,
        start: from,
      })
      .then((response) => {
        if (response.data.success)
          this.props.setBoxContent(
            true,
            <OrderConsultation
              toggle={this.toggleOrder}
              domain={this.props.domain}
              lawyer={this.props.lawyer}
              schedules={this.state.schedules}
              isFree={this.props.lawyer && this.props.lawyer.isFree}
              isSubscription={this.props.lawyer && this.props.lawyer.isFree}
              refetchService={() => {}}
              time={{
                start: from,
                end: to,
              }}
              price={
                this.props.lawyer && this.props.lawyer.isFree
                  ? 0
                  : this.props.lawyer && this.props.lawyer.price
              }
              setBoxContent={this.props.setBoxContent}
            />,
            "Umówienie konsultacji",
            "Formularz",
            this.props.lawyer && this.props.lawyer.isFree ? null : 1,
            null
          );
      });
  };

  toggleProfile = () => {
    this.props.setCurrentLawyer &&
      this.props.setCurrentLawyer(this.props.lawyer.id, this.state.imageUrl);
    this.props.setBoxContent(
      true,
      <Profile
        lawyer={this.props.lawyer}
        setBoxContent={this.props.setBoxContent}
        domain={this.props.domain}
        domainName={this.props.domainName}
        services={this.props.lawyer && this.props.lawyer.services}
        opinions={this.state.opinions}
        toggleOpinions={this.toggleOpinions}
        togglePriceList={this.togglePriceList}
        price={this.props.lawyer && this.props.lawyer.price}
      />,
      "Profil prawnika",
      this.props.lawyer.lawyerStatus +
        " " +
        this.props.lawyer.name +
        " " +
        this.props.lawyer.surname,
      null,
      <Button
        variant="contained"
        color="primary"
        onClick={this.toggleSchedules}
      >
        <CalendarIcon2 /> Umów wideokonsultację
      </Button>
    );
  };

  toggleOpinions = () => {
    this.props.setCurrentLawyer &&
      this.props.setCurrentLawyer(this.props.lawyer.id, this.state.imageUrl);
    this.props.setBoxContent(
      true,
      <Opinions
        opinions={this.state.opinions}
        toggleSchedules={this.toggleSchedules}
        lawyer={this.state.lawyer}
      />,
      "Opinie od Klientów",
      this.props.lawyer.lawyerStatus +
        " " +
        this.props.lawyer.name +
        " " +
        this.props.lawyer.surname,
      null,
      <Button
        variant="contained"
        color="primary"
        onClick={this.toggleSchedules}
      >
        <CalendarIcon2 /> Umów wideokonsultację
      </Button>,
      null
    );
  };

  togglePriceList = () => {
    this.props.setCurrentLawyer &&
      this.props.setCurrentLawyer(this.props.lawyer.id, this.state.imageUrl);
    this.props.setBoxContent(
      true,
      <PriceList
        lawyer={this.props.lawyer}
        opinions={this.state.opinions}
        services={this.props.lawyer && this.props.lawyer.services}
        toggleOpinions={this.toggleOpinions}
        domainId={this.props.domain}
      />,
      "Cennik i usługi",
      this.props.lawyer.lawyerStatus +
        " " +
        this.props.lawyer.name +
        " " +
        this.props.lawyer.surname,
      null,
      <Button
        variant="contained"
        color="primary"
        className={styles.order}
        onClick={this.toggleSchedules}
      >
        <CalendarIcon2 /> Umawianie wideokonsultację
      </Button>,
      null
    );
  };

  render() {
    const { lawyer, currentUser } = this.props;
    const { opinions, firstFreeDay, imageUrl } = this.state;
    let opinionText = "opinii";

    if (opinions) {
      if (opinions.totalOpinionVerified === 1) opinionText = "opinia";
      else if (opinions.totalOpinionVerified < 5) opinionText = "opinie";
    }

    if (!this.props.lawyer) return null;
    else
      return (
        <div
          className={classNames({
            [styles.SingleLawyer]: true,
            [styles.active]: this.props.currentLawyer === lawyer.id,
            [styles.activeAppointment]:
              typeof this.props.appointment !== "undefined" ? false : true,
          })}
        >
          <div className={styles.header}>
            <div className={styles.left}>
              {imageUrl && (
                <img
                  src={imageUrl}
                  alt={lawyer.name}
                  className={styles.avatar}
                />
              )}
              {!imageUrl && (
                <div className={styles.noAvatar}>
                  <PersonRoundedIcon />
                </div>
              )}
            </div>

            <div className={styles.right}>
              <div className={styles.profession}>{lawyer.lawyerStatus}</div>
              <div className={styles.name}>
                {lawyer.name}
                <br />
                {lawyer.surname}
              </div>

              <StyledRating
                name="star-rating"
                value={opinions ? opinions.average : 0}
                precision={0.5}
                className={styles.star}
                //size="small"
                readOnly
                icon={<StarRoundedIcon />}
                emptyIcon={<StarBorderRoundedIcon />}
              />

              <span className={styles.more_link} onClick={this.toggleProfile}>
                {window.screen.availWidth > 1024
                  ? "Więcej o prawniku"
                  : "Więcej"}{" "}
                <img src={Arrow} alt="Arrow" />
              </span>

              <span
                className={styles.more_link + " " + styles.bottom}
                onClick={this.toggleOpinions}
              >
                {opinions.opinions ? opinions.totalOpinionVerified : 0}{" "}
                {opinionText}
                <img src={Arrow} alt="Arrow" />
              </span>
            </div>
          </div>
          <hr />
          <div className={styles.term}>
            <div className={styles.info}>
              <img src={IconCalendar} alt="Calendar icon" />
              {!this.props.appointment ||
              (this.props.appointment &&
                this.props.appointment.status === "Ended") ? (
                <span>
                  Najbliższy wolny termin:{" "}
                  <span className={styles.light}>{firstFreeDay}</span>
                </span>
              ) : null}
              {this.props.appointment &&
              this.props.appointment.status === "Planned" ? (
                <span>
                  Planowany termin:{" "}
                  <span className={styles.light}>
                    {moment(this.props.appointment.start).format(
                      "D MMMM YYYY, HH:mm",
                      "pl"
                    )}
                  </span>
                </span>
              ) : null}
            </div>

            {!this.props.appointment ||
            (this.props.appointment &&
              this.props.appointment.status === "Ended") ? (
              <div className={styles.schedulesRow}>
                <div className={styles.hours}>{this.nearestHours()}</div>

                <Button
                  variant="outlined"
                  color="primary"
                  endIcon={<img src={Arrow} alt="Arrow" />}
                  className={styles.moreButton}
                  onClick={this.toggleSchedules}
                >
                  Więcej
                </Button>
              </div>
            ) : null}
            {this.props.appointment &&
            this.props.appointment.status === "Planned" ? (
              <div className={styles.schedulesRow}>
                {moment(this.props.appointment.start).isAfter(
                  moment().add(30, "minutes")
                ) ? (
                  <Button
                    variant="outlined"
                    color="primary"
                    disabled={moment(this.props.appointment.start).isAfter(
                      moment().add(30, "minutes")
                    )}
                    className={styles.startAppointment}
                  >
                    Rozpocznij wideokonsultację
                  </Button>
                ) : (
                  <Link
                    to={
                      "/session/" +
                      encodeBase64String({
                        userId: currentUser.id,
                        name: `${currentUser.details.name} ${currentUser.details.surname}`,
                        sessionId: this.props.appointment.sessionId,
                      })
                    }
                    style={{ textDecorationLine: "none" }}
                    disabled={moment(this.props.appointment.start).isAfter(
                      moment().add(30, "minutes")
                    )}
                  >
                    <Button
                      variant="outlined"
                      color="primary"
                      disabled={moment(this.props.appointment.start).isAfter(
                        moment().add(30, "minutes")
                      )}
                      className={styles.startAppointment}
                    >
                      Rozpocznij wideokonsultację
                    </Button>
                  </Link>
                )}
              </div>
            ) : null}
          </div>
          <hr />
          <div className={styles.consultation}>
            <div className={styles.info}>
              <img src={Camera} alt="Camera" />
              <span>
                {this.props.lawyer && this.props.lawyer.isFree
                  ? "Konsultacja online i opłata za zlecenie"
                  : "Konsultacja online"}
                :{" "}
                <span className={styles.light}>
                  {this.props.lawyer && this.props.lawyer.isFree ? (
                    <span className={styles.red}>W ramach abonamentu</span>
                  ) : this.props.lawyer && this.props.lawyer.price ? (
                    this.props.lawyer.price + " zł"
                  ) : (
                    "--"
                  )}
                </span>
              </span>
            </div>
            {this.props.lawyer && !this.props.lawyer.isFree && (
              <span className={styles.more_link} onClick={this.togglePriceList}>
                Cennik <img src={Arrow} alt="Arrow" />
              </span>
            )}
          </div>
        </div>
      );
  }
}

SingleLawyer.defaultProps = {};

export default SingleLawyer;
